import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [],
  template: `<div class="text-secondary fs-18 fw-bold">{{message}}</div>`
})
export class EmptyStateComponent {
  @Input() message: string = 'No data found';
}
